// 版本管理页面
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Form, Table, Card, Button, Icon, Input, Divider, Select, Row } from 'antd';
import { message } from 'antd-v5';

import PageHeaderLayout from '../../component/page-header-layout/index';
import { appTypeList } from '../../utils/appType';
import { fetchAppList, fetchAppVerById } from '../../state/action/appVersion';

import './style.less';

import { updatePush } from '../../state/request/appVersion';
import qs from 'qs';

const { Column } = Table;
const FormItem = Form.Item;

@connect(
  (state) => {
    return { appVersion: state.appVersion };
  },
  { fetchAppList, fetchAppVerById },
)
@Form.create()
class VersionManagement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      loading: true,
      pageNo: 1,
      pageSize: 10,
    };
    this.updataState = this.updataState.bind(this);
  }

  componentDidMount() {
    const search = this.props.history.location.search;
    if (search) {
      const query = qs.parse(search, { ignoreQueryPrefix: true });
      const pageNo = Number(query.pageNo) || 1;
      const pageSize = Number(query.pageSize) || 10;
      const version = query.version != null ? String(query.version) : undefined;
      const appType = query.appType != null ? query.appType : 'all';
      this.props.form.setFieldsValue({
        version: version || '',
        appType,
      });
      const params = { pageNo, pageSize };
      if (version) params.version = version;
      if (appType !== undefined && appType !== 'all' && appType !== '全部') {
        params.appType = appType;
      }
      this.setState(
        {
          pageNo,
          pageSize,
          version,
          appType,
          loading: true,
        },
        () => this.fetchAppList(params),
      );
    } else {
      this.fetchAppList({ pageSize: 10, pageNo: 1 });
    }
  }

  // 将当前筛选与分页同步到 URL，便于从下级页 goBack 后还原
  replaceListQuery = () => {
    const { version, appType } = this.props.form.getFieldsValue();
    const { pageNo, pageSize } = this.state;
    const q = {};
    if (pageNo > 1) q.pageNo = pageNo;
    if (pageSize !== 10) q.pageSize = pageSize;
    if (version) q.version = version;
    if (appType !== undefined && appType !== 'all' && appType !== '全部') {
      q.appType = appType;
    }
    const search = Object.keys(q).length ? `?${qs.stringify(q)}` : '';
    if (search === this.props.history.location.search) return;
    this.props.history.replace({
      pathname: this.props.history.location.pathname,
      search,
    });
  };

  updataState(value) {
    this.setState({
      value: value,
    });
  }

  // 获取版本新增信息列表
  async fetchAppList(params) {
    await this.props.fetchAppList(params);
    this.setState({ loading: false });
  }

  // 查询版本号
  async fetchAppVerById(params) {
    await this.props.fetchAppVerById(params);
  }

  // 查询
  handleOnQuery = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }
      const { version, appType } = fieldsValue;
      let params = {
        pageSize: 10,
        pageNo: 1,
      };
      if (version !== undefined) {
        params.version = version;
      }
      if (appType !== undefined && appType !== 'all' && appType !== '全部') {
        params.appType = appType;
      }
      // 其他系统类型后台未生效
      this.setState({ ...params, ...fieldsValue, pageNo: 1, pageSize: 10 }, () => {
        this.replaceListQuery();
      });
      this.fetchAppList(params);
    });
  };

  // 分页切换
  pageSwitch = (obj) => {
    const pageNo = obj.current;
    const pageSize = obj.pageSize || this.state.pageSize;
    const params = { pageNo, pageSize };
    const { version, appType } = this.state;
    if (appType !== undefined && appType !== 'all' && appType !== '全部') {
      params.appType = appType;
    }
    params.version = version;
    this.setState({ pageNo, pageSize }, () => {
      this.replaceListQuery();
    });
    this.fetchAppList(params);
  };

  toTradingCompanyManagement(e, record) {
    e.preventDefault();
    if (record.versionType !== 1) {
      this.replaceListQuery();
      this.props.history.push(`/version/versionmanagement/tradingManagement/${record.id}`);
    }
  }
  toView(e, id) {
    e.preventDefault();
    this.replaceListQuery();
    this.props.history.push(`/version/versionmanagement/view/${id}`);
  }

  // 发送版本更新推送消息
  sendPushMsg = async (e, record) => {
    e.preventDefault();
    const { id, os } = record;
    if (os !== 'android') {
      return;
    }

    this.setState({
      loading: true,
    });

    const res = await updatePush({ versionId: id });
    if (res.code === 200) {
      message.success('推送成功');
    }
    this.setState({
      loading: false,
    });
  };
  toAdd() {
    this.props.history.push(`/version/versionmanagement/add`);
  }

  render() {
    const {
      appVersion: { appListData },
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    let versionLst = appListData.data;

    const total = appListData.total;
    const pagination = {
      current: this.state.pageNo,
      pageSize: this.state.pageSize,
      total: total,
    };
    const extraContent = (
      <div style={{ width: '100%' }}>
        <Form layout='inline' onSubmit={this.handleOnQuery} className='login-form'>
          <FormItem label='版本号'>
            {getFieldDecorator('version', {
              rules: [{ required: false, message: '搜索版本号!' }],
            })(
              <Input
                prefix={<Icon type='search' style={{ color: 'rgba(0,0,0,.25)' }} />}
                style={{ marginTop: '5px' }}
                placeholder='搜索版本号'
                allowClear={true}
              />,
            )}
          </FormItem>
          <FormItem label='应用类型'>
            {getFieldDecorator('appType', {
              rules: [{ required: false, message: '请选择应用类型!' }],
              initialValue: 'all',
            })(
              <Select style={{ width: 250 }}>
                {appTypeList.map((appType) => {
                  const { name, value } = appType;
                  return <Select.Option key={value}>{name ? name : ''}</Select.Option>;
                })}
              </Select>,
            )}
          </FormItem>
          <Row>
            <div style={{ marginTop: '5px' }}>
              <Button type='primary' style={{ width: 80 }} htmlType='submit'>
                查询
              </Button>
              <Button style={{ marginLeft: '12px', width: 80 }} onClick={() => this.toAdd()}>
                新增
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    );

    return (
      <div className='version-index'>
        <PageHeaderLayout>
          <div className={'batchLayout'}>
            <Card
              className={'listCard'}
              bordered={false}
              title=''
              bodyStyle={{ padding: '0 16px 40px 16px', marginTop: 12 }}
              extra={extraContent}
            >
              <Table
                rowKey={(record, index) => index}
                dataSource={versionLst}
                pagination={pagination}
                scroll={{ x: 600 }}
                bordered
                loading={this.state.loading}
                onChange={this.pageSwitch.bind(this)}
              >
                <Column title='版本号' dataIndex='version' key='version' />
                {/*  <Column title="系统类型" dataIndex="os" key="os" /> */}
                <Column
                  title='应用类型'
                  dataIndex='os'
                  key='os'
                  render={(text, record) => {
                    const { os } = record;
                    const item = appTypeList.find((g) => g.value === os);
                    return item ? item.name : os;
                  }}
                />
                <Column
                  title='是否强制升级'
                  dataIndex='isForce'
                  key='isForce'
                  render={(text, record) => {
                    const { isForce } = record;
                    return <span>{isForce ? '是' : '否'}</span>;
                  }}
                />
                <Column
                  title='版本类型'
                  dataIndex='versionType'
                  key='versionType'
                  render={(text, record) => {
                    if (text === 2) {
                      return '灰度';
                    }
                    return '全量';
                  }}
                />
                <Column
                  title='操作类型'
                  dataIndex='system'
                  key='system'
                  render={(text, record) => {
                    const { system } = record;
                    if (1 === system) {
                      return 'Android';
                    } else if (2 === system) {
                      return 'IOS';
                    } else {
                      return '-';
                    }
                  }}
                />
                <Column
                  title='审核状态'
                  dataIndex='releaseStatus'
                  key='releaseStatus'
                  render={(text, record) => {
                    const { releaseStatus } = record;
                    if (2 === releaseStatus) {
                      return '审核通过';
                    } else if (1 === releaseStatus) {
                      return <span style={{ color: '#f21717' }}>审核中</span>;
                    } else {
                      return '-';
                    }
                  }}
                />
                <Column
                  title='是否维护'
                  dataIndex='enable'
                  key='enable'
                  render={(text, record) => {
                    const { enable } = record;
                    if (0 === enable) {
                      return '否';
                    } else if (1 === enable) {
                      return '是';
                    } else {
                      return '-';
                    }
                  }}
                />
                <Column
                  title='操作'
                  dataIndex='currDayCreditAmount'
                  key='currDayCreditAmount'
                  render={(text, record) => {
                    const { id, versionType, os } = record;
                    //  href={`/version/view/${id}`}  href={`version/pushConfig/${id}`}
                    return (
                      <div>
                        <a href='/' onClick={(e) => this.toView(e, id)}>
                          修改
                        </a>
                        <Divider type='vertical' />
                        <a
                          href='/'
                          onClick={(e) => this.sendPushMsg(e, record)}
                          style={{ color: os === 'android' ? '#01b755' : '#c5bcbc' }}
                        >
                          推送更新
                        </a>
                        <Divider type='vertical' />
                        <a
                          style={{ color: versionType !== 1 ? '#01b755' : '#c5bcbc' }}
                          onClick={(e) => this.toTradingCompanyManagement(e, record)}
                          // href={versionType !== 1 ? `version/tradingCompanyManagement/${id}` : "javascript:;"}
                          href='/'
                        >
                          商行列表
                        </a>
                      </div>
                    );
                  }}
                />
              </Table>
            </Card>
          </div>
        </PageHeaderLayout>
      </div>
    );
  }
}
export default VersionManagement;
